import { render, staticRenderFns } from "./SalesInvoiceFooter.vue?vue&type=template&id=398f77a6"
import script from "./SalesInvoiceFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesInvoiceFooter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports